/**
 * 焦点图管理API服务
 */

angular.module('editingCenterAppFocusModule').service('appFocusApiService', [
    'trsHttpService',
    '$q',
    function(trsHttpService, $q) {
        let httpServer = trsHttpService.httpServer;

        /**
         * [sendRequest 公共发送请求方法]
         *
         * @param   {[type]}  params  [params 请求参数]
         * @param   {[type]}  method  [method HTTP方法]
         *
         * @return  {[promise]}          [return 返回Promise对象]
         */
        function sendRequest(params, method) {
            let deffered = $q.defer();
            httpServer(trsHttpService.getWCMRootUrl(), params, method).then(
                function(data) {
                    deffered.resolve(data);
                },
                function(data) {
                    deffered.reject(data);
                }
            );
            return deffered.promise;
        }

        /**
         * [getFocusQueue 查询焦点图任务队列]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        this.getFocusQueue = function(params) {
            let requestParams = angular.extend({}, params, {
                serviceid: 'mlf_appoper',
                methodname: 'queryFocusPicQueue',
            });
            return sendRequest(requestParams, 'post');
        };

        this.getFocusList = function(params) {
            let requestParams = angular.extend({}, params, {
                serviceid: 'mlf_appoper',
                methodname: 'queryFocusPicList',
            });
            return sendRequest(requestParams, 'post');
        };

        /**
         * [FocusUp 焦点图上架]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        this.FocusUp = function (params) {
            let requestParams = angular.extend({}, params, {
                serviceid: 'mlf_appoper',
                methodname: 'upFocusPics',
            });
            return sendRequest(requestParams, 'post');
        };
        
        /**
         * [FocusDown 焦点图下架]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        this.FocusDown = function (params) {
            let requestParams = angular.extend({}, params, {
                serviceid: 'mlf_appoper',
                methodname: 'downFocusPics',
            });
            return sendRequest(requestParams, 'post');
        };

        /**
         * [FocusDown 焦点图排序]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        this.FocusSort = function (params) {
            let requestParams = angular.extend({}, params, {
                serviceid: 'mlf_appoper',
                methodname: 'sortFocusPics',
            });
            return sendRequest(requestParams, 'post');
        };
        
        /**
         * [FocusCancelTiming 焦点图取消定时]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        this.FocusCancelTiming = function (params) {
            let requestParams = angular.extend({}, params, {
                serviceid: 'mlf_appoper',
                methodname: 'cancelFocusPicTiming',
            });
            return sendRequest(requestParams, 'post');
        };
    },
]);
